import { Component, getAssetPath, h, Host, Prop } from "@stencil/core";

/**
 * Webinar Speaker component - used to display details about the speaker
 * this component is used together with the webinar component
 * @slot - The main text
 */
@Component({
    tag: "ux-iws-webinar-speaker",
    styleUrl: "webinar-speaker.scss",
    shadow: true,
    assetsDirs: ["./assets"],
})
export class WebinarSpeaker {
    /**
     * The name of the speaker
     */
    @Prop() name: string;
    /**
     * image url
     */
    @Prop() image: string;
    /**
     * The designation of the speaker
     */
    @Prop() designation: string;

    render() {
        return (
            <Host>
                <div class="image-container">
                    <img
                        class="image"
                        src={
                            this.image ||
                            getAssetPath(
                                "./assets/webinar-speaker-fallback.jpg"
                            )
                        }
                        alt={this.name}
                        loading="lazy"
                    />
                </div>
                <div class="main-infos">
                    <div class="name">{this.name}</div>
                    <div class="designation">{this.designation}</div>
                </div>
                <div class="content">
                    <slot />
                </div>
            </Host>
        );
    }
}
